export default {
    INTERNA: 1,
    EXTERNA: 2,
}